import { Form, Input, Row, Col, Switch, Select, DatePicker, InputNumber, Space, Tooltip, Button } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import { SearchOutlined } from '@ant-design/icons';
import GiftCardPlansSelect from './customize/GiftCardPlansSelect';
import antdMessage from '../../../utilsTsx/components/system/antdMessage';
import WangeditorV5ForAntD from '../../../utilsTsx/components/wangeditor/WangeditorV5ForAntD';
import systematic from '../../../config/systematic';
import FilesInput from '../../../utilsTsx/components/files/FilesInput';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

const EditComponent = (props: any) => {
    const { editMode, defaultService } = props;
    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);
    const [giftCardTypeData, setGiftCardTypeData] = useState<any>();
    const [giftCardDeductionTypeData, setGiftCardDeductionTypeData] = useState<any>();
    const [validDaysModeData, setValidDaysModeData] = useState<any>();
    const [validDaysDisabled, setValidDaysDisabled] = useState<boolean>(true);
    const [returnData, setReturnData] = useState<any>();
    const [permanentUseDisabled, setPermanentUseDisabled] = useState<boolean>(false);
    const [id, setId] = useState<string>();

    /** 设置validDays状态 */
    const setValidDaysStates = (validDaysModeId: number) => {
        if (typeof validDaysModeId === 'undefined') {
            return;
        }
        if (validDaysModeId === 1 || validDaysModeId === 3 || validDaysModeId === 5) {
            setValidDaysDisabled(false);
        } else {
            setValidDaysDisabled(true);
        }
    };

    useEffect(() => {
        ref?.current?.getRow?.then(async (res: any) => {
            if (res?.success === true) {
                const { id, queryURL, validDaysModeId, isPermanentUse } = res.data;
                if (queryURL) {
                    getReturnData();
                }
                setValidDaysStates(validDaysModeId);
                setPermanentUseDisabled(isPermanentUse);
                setId(id);
            }
        })

        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'giftCardType@giftCardDeductionType@validDaysMode',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { giftCardType, giftCardDeductionType, validDaysMode } = res.data;
                    setGiftCardTypeData(giftCardType);
                    setGiftCardDeductionTypeData(giftCardDeductionType);
                    setValidDaysModeData(validDaysMode);
                }
            })
    }, []);

    /**
     * 获取返回数据
     * @param url 地址
     */
    const getReturnData = async () => {
        const serviceUrl = form.getFieldValue('queryURL');
        try {
            const res = await fetchApi.GET(serviceUrl);
            if (res.success === true) {
                antdMessage('info', '查询成功！');
                setReturnData(res.data);
            } else {
                antdMessage('error', '无资料！');
            }
        }
        catch (err: any) {
            const { message } = err;
            antdMessage('error', `无资料！${message}`);
        }
    };

    const extendProps: WebEditUniversalProps = {
        ...props,
        apiId: 'giftCardPlans',
        serviceId: 'business',
        displayOptions: {
            width: 1380
        },
        dateOptions: {
            columnNames: ['startDate', 'endDate', 'validStartDate', 'validEndDate']
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={14}>
                        <Row gutter={[8, 0]}>
                            <Col span={6}>
                                <Form.Item
                                    label="ID"
                                    name="id">
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>

                            <Col span={18}>
                                <Form.Item
                                    label="方案"
                                    name="planName"
                                    rules={[{ required: true, message: '方案名称!' }]}>
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={6}>
                                <Form.Item
                                    label="类型"
                                    name="giftCardTypeId"
                                    rules={[{ required: true, message: '请选择类型!' }]}>
                                    <Select
                                        showSearch
                                        placeholder="类型"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                        {getList.general(giftCardTypeData)}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={9}>
                                <Form.Item
                                    label="方案开始"
                                    name="startDate"
                                    tooltip='方案的开始日期'>
                                    <DatePicker
                                        disabled={permanentUseDisabled}
                                        format="YYYY-MM-DD HH:mm:ss" />
                                </Form.Item>
                            </Col>

                            <Col span={9}>
                                <Form.Item
                                    label="方案结束"
                                    name="endDate"
                                    tooltip='方案的结束日期'>
                                    <DatePicker
                                        disabled={permanentUseDisabled}
                                        format="YYYY-MM-DD HH:mm:ss" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="扣款"
                                    name="giftCardDeductionTypeIds"
                                    tooltip='请选择扣款，并设定默认'
                                    rules={[{ required: true, message: '请选择扣款，并设定默认!' }]}>
                                    <GiftCardPlansSelect
                                        dataSource={giftCardDeductionTypeData}
                                        placeholder="选择扣款"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={6}>
                                <Form.Item
                                    label="面值"
                                    name="faceValue"
                                    tooltip='礼品卡面值（元）'
                                    rules={[{ required: true, message: '请输入礼品卡面值!' }]}>
                                    <InputNumber style={{ width: 120 }} />
                                </Form.Item>
                            </Col>

                            <Col span={9}>
                                <Form.Item
                                    label="开始日期"
                                    name="validStartDate"
                                    tooltip='礼品卡有效开始日期'>
                                    <DatePicker
                                        disabled={!validDaysDisabled}
                                        format="YYYY-MM-DD HH:mm:ss"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={9}>
                                <Form.Item
                                    label="结束日期"
                                    name="validEndDate"
                                    tooltip='礼品卡有效结束日期'>
                                    <DatePicker
                                        disabled={!validDaysDisabled}
                                        format="YYYY-MM-DD HH:mm:ss"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={5}>
                                <Form.Item
                                    label="平台价"
                                    name="platformPrice"
                                    tooltip='在其它平台售价（元）'>
                                    <InputNumber style={{ width: 80 }} />
                                </Form.Item>
                            </Col>

                            <Col span={5}>
                                <Form.Item
                                    label="已用"
                                    name="usedCopies"
                                    tooltip='方案已用份数'>
                                    <InputNumber
                                        disabled={editMode === 'NEW' ? true : false}
                                        style={{ width: 95 }} />
                                </Form.Item>
                            </Col>

                            <Col span={5}>
                                <Form.Item
                                    label="总数"
                                    name="totalCopies"
                                    tooltip='方案的总份数' >
                                    <InputNumber
                                        disabled={permanentUseDisabled}
                                        style={{ width: 95 }} />
                                </Form.Item>
                            </Col>

                            <Col span={5}>
                                <Form.Item
                                    label="有效期"
                                    name="validDays"
                                    tooltip='有效期（天）'
                                    initialValue={360}>
                                    <InputNumber
                                        disabled={validDaysDisabled}
                                        style={{ width: 80 }} />
                                </Form.Item>
                            </Col>

                            <Col span={3}>
                                <Form.Item
                                    label="排序"
                                    name="sorting"
                                    tooltip='排序，数字小排前面'>
                                    <InputNumber style={{ width: 50 }} />
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item
                                    label="模式"
                                    name="validDaysModeId"
                                    tooltip="根据不同有效期模式生成礼品卡有效期"
                                    rules={[{ required: true, message: '请选择有效期模式!' }]}>
                                    <Select
                                        showSearch
                                        placeholder="有效期模式"
                                        optionFilterProp="children"
                                        onSelect={(value) => setValidDaysStates(value)}
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                        {getList.general(validDaysModeData)}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={16}>
                                <Form.Item
                                    label="查询网址"
                                    name="queryURL"
                                    tooltip='获取回传数据列表的网址，用GET方法，返回数据符合RtnType(JSON)。
                                例如返回值：{ success: boolean, data: Array<{id: string, name: string}> }'>
                                    <Space.Compact>
                                        <Input
                                            value={Form.useWatch('queryURL', form)}
                                            onChange={(e) => form.setFieldsValue({ queryURL: e.target.value })}
                                            style={{ width: 350 }}
                                        />
                                        <Tooltip title="查询资料">
                                            <Button type="primary" shape="circle" icon={<SearchOutlined />}
                                                onClick={() => getReturnData()} />
                                        </Tooltip>
                                    </Space.Compact>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="回传"
                                    name="returnData"
                                    tooltip="回传数据">
                                    <Select
                                        showSearch
                                        placeholder="回传数据"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                        {getList.general(returnData)}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="封面图"
                                    name="coverImage"
                                    tooltip='礼品卡封面图地址'>
                                    <FilesInput
                                        defaultService={systematic.bmService}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={4}>
                                <Form.Item
                                    label="新客"
                                    name="isExclusiveToNewCustomers"
                                    tooltip='新客专用'
                                    valuePropName="checked"
                                    initialValue={false}>
                                    < Switch checked={false}
                                        checkedChildren="是"
                                        unCheckedChildren="否" />
                                </Form.Item>
                            </Col>

                            <Col span={3}>
                                <Form.Item
                                    label="默认"
                                    name="isDefault"
                                    valuePropName="checked"
                                    initialValue={false}>
                                    < Switch checked={false}
                                        checkedChildren="是"
                                        unCheckedChildren="否" />
                                </Form.Item>
                            </Col>

                            <Col span={5}>
                                <Form.Item
                                    label="可购数"
                                    name="allowQuantityPerPurchase"
                                    tooltip='充许每次购买数量'>
                                    <InputNumber style={{ width: 80 }} />
                                </Form.Item>
                            </Col>

                            <Col span={4}>
                                <Form.Item
                                    label="限购数"
                                    name="purchaseLimit"
                                    tooltip='该方案充许每人限购总数量，0：不限额'>
                                    <InputNumber style={{ width: 50 }} />
                                </Form.Item>
                            </Col>

                            <Col span={4}>
                                <Form.Item
                                    label="充值"
                                    name="isRechargeable"
                                    tooltip='是否充许充值'
                                    valuePropName="checked"
                                    initialValue={false}>
                                    < Switch checked={false}
                                        checkedChildren="是"
                                        unCheckedChildren="否" />
                                </Form.Item>
                            </Col>

                            <Col span={3}>
                                <Form.Item
                                    label="转赠"
                                    name="isTransferable"
                                    tooltip='是否充许转赠'
                                    valuePropName="checked"
                                    initialValue={false}>
                                    < Switch checked={false}
                                        checkedChildren="是"
                                        unCheckedChildren="否" />
                                </Form.Item>
                            </Col>

                            <Col span={4}>
                                <Form.Item
                                    label="会员"
                                    name="isBoundToMember"
                                    tooltip='是否需要绑定会员才能使用'
                                    valuePropName="checked"
                                    initialValue={false}>
                                    < Switch checked={false}
                                        checkedChildren="是"
                                        unCheckedChildren="否" />
                                </Form.Item>
                            </Col>

                            <Col span={5}>
                                <Form.Item
                                    label="自动退款"
                                    name="isAutoRefunds"
                                    tooltip='当前方案是否充许自动退款'
                                    valuePropName="checked"
                                    initialValue={false}>
                                    < Switch checked={false}
                                        checkedChildren="是"
                                        unCheckedChildren="否" />
                                </Form.Item>
                            </Col>

                            <Col span={4}>
                                <Form.Item
                                    label="退款"
                                    name="isAllowRefunds"
                                    tooltip='当前方案是否充许退款'
                                    valuePropName="checked"
                                    initialValue={false}>
                                    < Switch checked={false}
                                        checkedChildren="是"
                                        unCheckedChildren="否" />
                                </Form.Item>
                            </Col>

                            <Col span={4}>
                                <Form.Item
                                    label="冲正"
                                    name="isAllowRevoke"
                                    tooltip='当前方案是否充许冲正'
                                    valuePropName="checked"
                                    initialValue={false}>
                                    < Switch checked={false}
                                        checkedChildren="是"
                                        unCheckedChildren="否" />
                                </Form.Item>
                            </Col>

                            <Col span={4}>
                                <Form.Item
                                    label="过期退"
                                    name="isRefundIfExpired"
                                    tooltip='过期后自动退'
                                    valuePropName="checked"
                                    initialValue={false}>
                                    < Switch checked={false}
                                        checkedChildren="是"
                                        unCheckedChildren="否" />
                                </Form.Item>
                            </Col>

                            <Col span={3}>
                                <Form.Item
                                    label="永久"
                                    name="isPermanentUse"
                                    tooltip='方案永久使用'
                                    valuePropName="checked"
                                    initialValue={false}>
                                    < Switch
                                        onChange={(e) => {
                                            setPermanentUseDisabled(e);
                                        }}
                                        checked={false}
                                        checkedChildren="是"
                                        unCheckedChildren="否" />
                                </Form.Item>
                            </Col>

                            <Col span={3}>
                                <Form.Item
                                    label="显示"
                                    name="isShow"
                                    valuePropName="checked"
                                    initialValue={true}>
                                    < Switch checked={true}
                                        checkedChildren="是"
                                        unCheckedChildren="否" />
                                </Form.Item>
                            </Col>

                            <Col span={3}>
                                <Form.Item
                                    label="状态"
                                    name="isUse"
                                    valuePropName="checked"
                                    initialValue={true}>
                                    < Switch checked={true}
                                        checkedChildren="启用"
                                        unCheckedChildren="关闭" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="备注"
                                    name="remarks">
                                    < Input.TextArea autoSize={{ minRows: 2, maxRows: 10 }} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={10}>
                        <Form.Item
                            label=""
                            name="details">
                            {id ? (
                                <WangeditorV5ForAntD
                                    key={id}
                                    id={`giftCardPlans${id}`}
                                    title='详情'
                                    displayMode="editor"
                                    defaultService={systematic.bmService}
                                    style={{ height: 500 }}
                                />
                            ) : null}
                        </Form.Item>
                    </Col>
                </Row>
            )
        }
    };
    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;